<template>
  <div>
    <div>
      <div class="topBox">
        <div class="sideList">
          <img src="../../assets/left.png" @click="linkBack()" />
        </div>
        <div class="mainList">添加经销商</div>
        <div class="sideList"></div>
      </div>
      <div class="topH"></div>
    </div>
    <div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="cName"
          name="cName"
          label="经销商名称"
          placeholder="请填写经销商名称"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="cMobile"
          name="cMobile"
          label="手机号"
          placeholder="请填写手机号"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="cSMCustomerId"
          name="cSMCustomerId"
          label="经销商编号"
          placeholder="请填写经销商编号"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          readonly
          clickable
          name="area"
          v-model="pca"
          :value="value"
          label="地区选择"
          placeholder="点击选择省市区"
          @click="showArea = true"
        />
        <van-field
          v-model="cContact"
          name="cContact"
          label="联系人"
          placeholder="请填写联系人名称"
          :rules="[{ required: true, message: '' }]"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
        </van-popup>
        <van-field
          v-model="cAddress"
          name="cAddress"
          label="联系地址"
          placeholder="请填写联系地址"
          :rules="[{ required: true, message: '' }]"
        />
        <div class="subBtn" @click="subForm()">提交</div>
      </van-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  CellGroup,
  Cell,
  Button,
  Form,
  Field,
  Popup,
  Area,
  Toast,
  Dialog,
} from "vant";
import area from "../../assets/area";

export default {
  data() {
    return {
      cName: "",
      cSMCustomerId: "",
      cProvince: "",
      cCity: "",
      cCounty: "",
      pca: "",
      cMobile: "",
      cAddress: "",
      cContact:"",
      showArea: false,
      areaList: {}, // 数据格式见 Area 组件文档
    };
  },

  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    [Dialog.name]: Dialog,
  },
  methods: {
    linkBack() {
      this.$router.go(-1);
    },
    onConfirm(values) {
      this.pca = values.map((item) => item.name).join("/");
      this.showArea = false;
    },
    subForm() {
      var _this = this;
      if (this.cName == "") {
        Toast("请填写经销商名称");
        return;
      }
      if (this.cMobile == "") {
        Toast("请填写手机号");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.cMobile)) {
        Toast("手机号码有误，请重填");
        return false;
      }
      if (this.cSMCustomerId == "") {
        Toast("请填写经销商编号");
        return;
      }
       if (this.cContact == "") {
        Toast("请填写联系人姓名");
        return;
      }
      if (this.pca == "") {
        Toast("请选择省市区");
        return;
      }
      if (this.cAddress == "") {
        Toast("请选择详情地址");
        return;
      }
      var dd = {
        cName: this.cName,
        cSMCustomerId: this.cSMCustomerId,
        cProvince: this.pca.split("/")[0],
        cCity: this.pca.split("/")[1],
        cCounty: this.pca.split("/")[2],
        cMobile: this.cMobile,
        cAddress: this.cAddress,
        cSerialNumber: this.cSMCustomerId,
        cContact:this.cContact,
        ticket: sessionStorage.getItem("ticket"),
      };
      this.$post("/api/PhoneAPI/AddCustomer", dd)
        .then((res) => {
          if (res.IsSucceed) {
            Dialog.alert({
              message: res.Message,
            }).then(() => {
              _this.linkBack();
            });
          } else {
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.areaList.province_list = area.province_list;
    this.areaList.city_list = area.city_list;
    this.areaList.county_list = area.county_list;
  },
};
</script>
<style scoped>
.topBox {
  width: 375px;
  height: 44px;
  background-color: #444444;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  align-content: center;
  justify-content: space-between;
}
.topH {
  height: 44px;
}
.sideList {
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sideList img {
  width: 18px;
  height: 18px;
  margin-right: 30px;
}
.mainList {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
}
.subBtn {
  width: 200px;
  margin: 0 auto;
  background: #e62129;
  color: white;
  font-size: 16px;
  border-radius: 5px;
  line-height: 36px;
  height: 36px;
  margin-top: 40px;
}
</style>
